import { isPasswordRecoveryRoute } from './passwordRecoveryRoutes.js'

const topics = new Set(('estrutura-basica variaveis-leia tipos-numericos constantes-formatacao tipos-texto-logico operadores-aritmeticos operadores-relacionais operadores-logicos condicional-se escolha-caso laco-para laco-enquanto laco-repita comando-interrompa vetores matrizes procedimentos parametros-referencia funcoes funcoes-nativas comandos-tela aleatoriedade manipulacao-strings conversoes-ascii depuracao-debug exemplo-calculadora exemplo-jogo').split(' '))
const publicPages = new Set(('sobre visual-gusto professores o-que-e-portugol o-que-e-visualg o-que-e-programacao como-aprender-python o-que-e-linguagem-de-programacao pseudocodigo baixar-visualg exercicios-portugol-resolvidos-visualg estruturas-de-repeticao tipos-de-dados').split(' '))
const languages = new Set(['visualg', 'visual-cobra', 'python'])

export const isSensitiveAnalyticsRoute = pathname => isPasswordRecoveryRoute(pathname)
  || /^\/(backoffice|debug-chat|debug-offers|checkout|conta|jornada)(\/|$)/.test(pathname)
  || /^\/cursos\/meus(\/|$)/.test(pathname)

export function publicAnalyticsContext(pathname = '/', properties = {}) {
  const segments = pathname.replace(/\/+$/, '').split('/').filter(Boolean)
  const topic = String(properties.topic_id || '').replace(/^_+/, '').replaceAll('_', '-')
  const contentId = topics.has(topic) ? topic
    : topics.has(segments[2]) && segments[0] === 'aprender' && languages.has(segments[1]) ? segments[2]
      : publicPages.has(segments.at(-1)) ? segments.at(-1)
        : pathname === '/' ? 'editor' : segments[0] === 'aprender' && segments.length === 1 ? 'learning-hub' : 'other'
  const language = languages.has(properties.language) ? properties.language
    : segments[0] === 'aprender' && languages.has(segments[1]) ? segments[1] : 'unknown'
  return { content_id: contentId, language }
}

const isHost = (hostname, domain) => hostname === domain || hostname.endsWith(`.${domain}`)
export function acquisitionSource({ referrer = '', search = '', origin = '' } = {}) {
  let host = ''
  try {
    const url = new URL(referrer)
    if (url.origin !== origin && ['https:', 'http:'].includes(url.protocol)) host = url.hostname.toLowerCase()
  } catch { /* Empty or invalid referrers have no attributable host. */ }
  if (isHost(host, 'chatgpt.com') || host === 'chat.openai.com') return 'chatgpt'
  if (isHost(host, 'perplexity.ai')) return 'perplexity'
  if (isHost(host, 'claude.ai')) return 'claude'
  if (host === 'gemini.google.com') return 'gemini'
  if (host === 'copilot.microsoft.com') return 'copilot'
  if (['google.com', 'www.google.com', 'google.com.br', 'www.google.com.br', 'google.pt', 'www.google.pt'].includes(host)) return 'google_search'
  if (['bing.com', 'www.bing.com'].includes(host)) return 'bing_search'
  const declared = new URLSearchParams(search).get('utm_source')?.toLowerCase()
  const sources = { chatgpt: 'chatgpt', 'chatgpt.com': 'chatgpt', perplexity: 'perplexity', 'perplexity.ai': 'perplexity', copilot: 'copilot', claude: 'claude', gemini: 'gemini' }
  if (Object.hasOwn(sources, declared)) return sources[declared]
  return host ? 'other' : 'unknown'
}
